<template>
  <div>
    <woot-loading-state
        v-if="uiFlags.isLoading"
        :message="$t('REPORT.LOADING_CHART')"
    />
    <div v-else>
        <BarChartApex
        v-if="graphData.dataList.length"
        :series="graphData.dataList"
        :categories="graphData.barNames"
        :title="{text:`${$t('CALENDAR_MGMT.REPORTS.MEETING.CHART_TITLE')}`}"
        />
      <empty-state v-if="!graphData.dataList.length" :title="$t('CALENDAR_MGMT.REPORTS.MEETING.NO_DATA')"/>
    </div>

  </div>
</template>

<script>
import BarChartApex from 'components/widgets/chart/BarChartApex.vue';
import { mapGetters } from 'vuex';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';

export default {
  components: {
    BarChartApex,
    EmptyState,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      meetingReports: "meetings/getMeetingReports",
      uiFlags: "meetings/getUIFlags",
    }),
   graphData(){
    const report = this.meetingReports || {};
    const weekDays = Object.keys(report);
    const valueMap = {};

    weekDays.forEach((day, dayIndex) => {
        const items = this.meetingReports?.[day] || {};
        Object.entries(items).forEach(([key, count]) => {
            if (!valueMap[key]) {
                valueMap[key] = Array(7).fill(0);
            }
            valueMap[key][dayIndex] = count;
        });
    });

    const dataList = Object.entries(valueMap).map(([name, data]) => ({
        name,
        data,
    }));

    const barNames = weekDays.map(day => day.charAt(0).toUpperCase() + day.slice(1));

    return {
        barNames,
        dataList,
    };
    // const barNames = ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2', '2012 Q3', '2012 Q4'];
    //   const dataList = [
    //     { name: 'Redeem', data: [44, 55, 41, 67, 22, 43, 21, 49] },
    //     { name: 'Not redeem', data: [13, 23, 20, 8, 13, 27, 33, 12] },
    //     // { name: 'PRODUCT C', data: [11, 17, 15, 15, 21, 14, 15, 13] }
    //   ]
    //   return {
    //     barNames,
    //     dataList
    //   }
   },
  },
};
</script>

<style>

</style>